// extracted by mini-css-extract-plugin
module.exports = {"hera":"hera-page_hera__jZoPG","banner":"hera-page_banner__Ho9wd","notification":"hera-page_notification__CW_8J"};